(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone-campaign-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-iphone-event]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = section.querySelectorAll('.ie-reveal');
    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      reveals.forEach((item) => observer.observe(item));
    }
    const progress = section.querySelector('.ie-progress');
    const parallax = section.querySelector('[data-ie-parallax]');
    let scheduled = false;
    const render = () => {
      const rect = section.getBoundingClientRect();
      const scrollable = Math.max(section.offsetHeight - window.innerHeight, 1);
      const progressValue = Math.min(Math.max(-rect.top / scrollable, 0), 1);
      if (progress) progress.style.transform = `scaleX(${progressValue})`;
      if (parallax && !reduced) {
        const amount = Math.min(Math.max(-rect.top * 0.08, 0), 45);
        parallax.style.transform = `translate3d(0, ${amount}px, 0) scale(1.04)`;
      }
      scheduled = false;
    };
    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(render);
    }, { passive: true });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z3-premium-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.z3Initialized) return;
    root.dataset.z3Initialized = 'true';
    const tiers = root.querySelectorAll('[data-z3-tier]');
    const reward = root.querySelector('[data-z3-reward]');
    tiers.forEach((button) => button.addEventListener('click', () => {
      tiers.forEach((tier) => tier.setAttribute('aria-pressed', String(tier === button)));
      if (reward) reward.textContent = '$' + button.dataset.z3Tier;
    }));
    const motion = window.matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)');
    if (root.dataset.motion !== 'true') return;
    root.querySelectorAll('[data-z3-tilt]').forEach((stage) => {
      let frame = 0;
      let box;
      stage.addEventListener('pointerenter', () => { box = stage.getBoundingClientRect(); });
      stage.addEventListener('pointermove', (event) => {
        if (!motion.matches || !box) return;
        const x = ((event.clientX - box.left) / box.width - 0.5) * 5;
        const y = ((event.clientY - box.top) / box.height - 0.5) * -5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          stage.style.setProperty('--rx', y.toFixed(2) + 'deg');
          stage.style.setProperty('--ry', x.toFixed(2) + 'deg');
        });
      });
      const reset = () => {
        cancelAnimationFrame(frame);
        stage.style.removeProperty('--rx');
        stage.style.removeProperty('--ry');
      };
      stage.addEventListener('pointerleave', reset);
      motion.addEventListener('change', reset);
    });
  };
  document.querySelectorAll('[data-z3-home]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-z3-home]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();
})();
